module.exports = __webpack_public_path__ + "static/media/021-rain.4628f5f5.svg";